import { render } from "./GoogleLogin.vue?vue&type=template&id=10cad0e2&scoped=true"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"

import "./GoogleLogin.vue?vue&type=style&index=0&id=10cad0e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cad0e2"]])

export default __exports__